// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1Y_xI","log":"ModalInventoryLogs_log__2jy8_","date":"ModalInventoryLogs_date__NYyE5","userName":"ModalInventoryLogs_userName__2ivz5"};